import type { ReactNode } from "react";
import { ArrowUpRight } from "lucide-react";

type ContactButtonProps = {
  href?: string;
  children?: ReactNode;
  download?: boolean | string;
  icon?: ReactNode;
};

export function ContactButton({
  href = "#contact",
  children = "联系我",
  download,
  icon = <ArrowUpRight className="h-4 w-4" strokeWidth={2.2} aria-hidden="true" />,
}: ContactButtonProps) {
  const opensNewTab = /^https?:\/\//.test(href);

  return (
    <a
      href={href}
      download={download || undefined}
      target={opensNewTab ? "_blank" : undefined}
      rel={opensNewTab ? "noreferrer" : undefined}
      className="contact-button inline-flex min-h-11 shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-full px-6 py-3 text-sm font-semibold tracking-wide transition-[filter,transform] duration-200 hover:brightness-110 active:scale-[0.98] sm:px-8 sm:text-base"
    >
      {children}
      {icon}
    </a>
  );
}
